<!-- /*--############################################################################
# Filename : SLS02_022RPT.vue                                                  
# Description : 매출관리 > 사원카드 매출현황 > 후불결제별 매출현황.            
# Date :2025-05-14                                                             
# Author : 권맑음                     
################################################################################*/ -->
<template>
  <!-- 조회 조건 -->
  <div class="h-full" @click="handleParentClick">
    <div class="flex justify-between items-center w-full overflow-y-hidden">
      <PageName></PageName>
      <div class="flex justify-center mr-9 space-x-2 pr-5">
        <button @click="searchButton" class="button search md:w-auto w-14">
          조회
        </button>
        <button @click="excelButton" class="button save w-auto excel">
          엑셀
        </button>
      </div>
    </div>
    <div
      class="grid grid-cols-2 grid-rows-3 bg-gray-200 rounded-lg h-36 items-start z-10">
      <div class="justify-start flex">
        <Datepicker2
          @startDate="startDate"
          @endDate="endDate"
          :closePopUp="closePopUp"
          ref="datepicker"
          class="pr-20"
          :selectedGroup="selectedGroup"
          @excelDate="excelDate" />
      </div>
      <div class="">
        <pickStoreRenew
          @lngStoreCode="lngStoreCode"
          @lngStoreGroup="lngStoreGroup"
          @excelStore="excelStore"
          class=""
          @lngStoreAttrs="lngStoreAttrs"
          :placeholderName="'전체'"></pickStoreRenew>
      </div>
      <div class="flex justify-start items-center space-x-5 ml-12 mt-2">
        <div class="text-base font-semibold">조회조건</div>
        <select
          name=""
          id=""
          class="w-64 h-8 rounded-lg"
          v-model="selectedCond">
          <option :value="0">전체</option>
          <option :value="i.strDCode" v-for="i in optionList">
            {{ i.strDName }}
          </option>
        </select>
      </div>
      <div class="flex justify-start items-center mt-2 space-x-5 !-ml-4">
        <div class="text-base font-semibold text-nowrap">조회옵션</div>
        <label for="unite"
          ><input
            type="checkbox"
            id="unite"
            @click="setUnite"
            checked />셀병합</label
        >
        <label for="sum"
          ><input type="checkbox" id="sum" @click="setSum" checked />합계</label
        >
        <label for="except"
          ><input
            type="checkbox"
            id="except"
            @click="exceptRetire" />퇴직자제외</label
        >
      </div>

      <div class="flex justify-start items-center h-8 space-x-5">
        <div class="text-base font-semibold text-nowrap ml-12">검색조건</div>
        <select
          name=""
          id=""
          class="w-20 h-8 rounded-lg flex justify-start ml-5"
          v-model="selectedCond2">
          <option :value="0">카드번호</option>
          <option :value="1">사원번호</option>
          <option :value="2">사원명</option>
          <option :value="3">부서명</option>
          <option :value="4">소속사명</option>
        </select>

        <!-- 카드번호/사원번호/사원명: 항상 input -->
        <input
          type="text"
          class="w-64 h-8 rounded-lg"
          v-model="cond2Text"
          v-if="selectedCond2 !== 3 && selectedCond2 !== 4" />

        <!-- 부서명/소속사명 + 3071 법인: select box (기존 방식) -->
        <select
          name=""
          id=""
          class="w-64 h-8 rounded-lg"
          v-model="selectedCond4"
          v-if="isLegacyGroup && (selectedCond2 == 3 || selectedCond2 == 4)">
          <option :value="i.strBelongNM" v-for="i in condition4List">
            {{ i.strBelongNM }}
          </option>
        </select>

        <!-- 부서명/소속사명 + 3071 외 법인: input text (새로운 방식) -->
        <input
          type="text"
          class="w-64 h-8 rounded-lg"
          v-model="cond2Text"
          v-if="!isLegacyGroup && (selectedCond2 == 3 || selectedCond2 == 4)" />

        <!-- 새로고침 버튼: 3071 법인만 -->
        <button
          @click="searchCondition"
          class="button primary"
          v-if="isLegacyGroup && (selectedCond2 == 3 || selectedCond2 == 4)">
          새로고침
        </button>
      </div>

      <div class="flex justify-start items-center h-8 space-x-5 -ml-4">
        <div class="text-base font-semibold">포스선택</div>
        <select name="" id="" class="w-32 rounded-lg h-8" v-model="selectedPos">
          <option :value="0">전체</option>
          <option :value="i.lngCode" v-for="i in posList">
            {{ i.lngCode }}
          </option>
        </select>
      </div>
    </div>
    <!-- 조회 조건 -->
    <!-- 그리드 영역 -->
    <div class="w-full h-[82%]">
      <Realgrid
        :progname="'SLS02_022RPT_VUE'"
        :progid="1"
        :rowData="rowData"
        :reload="reload"
        :setFooter="true"
        :documentTitle="'SLS02_022RPT'"
        :setGroupFooter="setGroupFooter"
        :setGroupColumnId="'strType,dtmDate'"
        :setRowGroupSpan2="setRowGroupSpan2"
        :mergeMask="''"
        :setFooterCustomColumnId="['dtmDate']"
        :setMergeMode="false"
        :setFooterCustomText="['합계']"
        :exportExcelShowColumns="['SubGroupNm']"
        :setGroupSumCustomColumnId2="['dtmDate', 'strCompName']"
        :setGroupSumCustomText2="[
          ['', '소계'],
          ['소계', ''],
        ]"
        :setGroupCustomLevel="3"
        :documentSubTitle="documentSubTitle"
        :rowStateeditable="false"
        :exporttoExcel="exportExcel">
      </Realgrid>
    </div>
  </div>
  <!-- 그리드 영역 -->
</template>

<script setup>
import { getCommonList, getPosList2 } from "@/api/common";
import { getCondition4List, getSalesbyPostPay } from "@/api/misales";
/**
 *  매출 일자 세팅 컴포넌트
 *  */

import Datepicker2 from "@/components/Datepicker2.vue";
/**
 *  페이지명 자동 입력 컴포넌트
 *  */

import PageName from "@/components/pageName.vue";
/**
 * 	매장 단일 선택 컴포넌트
 */
import pickStoreRenew from "@/components/pickStoreRenew.vue";
/**
 * 	그리드 생성
 */

import Realgrid from "@/components/realgrid.vue";
/**
 *  페이지로그 자동 입력
 *  */

import { insertPageLog } from "@/customFunc/customFunc";
/**
 *  경고창 호출 라이브러리
 *  */

import Swal from "sweetalert2";
/*
 * 공통 표준  Function
 */

import { computed, onMounted, ref, watch } from "vue";
/**
 *  Vuex 상태관리 및 로그인세션 관련 라이브러리
 */

import { useStore } from "vuex";
/**
 * 	화면 Load시 실행 스크립트
 */

const store = useStore();
const loginedstrLang = store.state.userData.lngLanguage;

// 3071 법인 여부 (기존 select box 방식)
const isLegacyGroup = computed(
  () => store.state.userData.lngPosition == "3071537"
);

const exception = ref(false);
const optionList = ref([]);
onMounted(async () => {
  const pageLog = await insertPageLog(store.state.activeTab2);

  if (store.state.userData.lngStoreGroup == "3193") {
    exception.value = true;
  } else {
    exception.value = false;
  }

  if (store.state.userData.lngStoreGroup == "1592") {
    const res = await getCommonList(342);
    optionList.value = res.data.List;
  } else if (store.state.userData.lngStoreGroup == "3193") {
    const res = await getCommonList(351);
    optionList.value = res.data.List;
  } else {
    const res = await getCommonList(89);
    optionList.value = res.data.List;
  }
});
const setFooterColID = ref(["strStoreName"]);
const setFooterExpressions = ref(["custom"]);
const setRowGroupSpan2 = ref(
  "strType,dtmDate,strCompName,lngEmpNo,strEmpName,strDeptInfo"
);
const setGroupFooter = ref(true);
const reload = ref(false);
const rowData = ref([]);
const afterSearch = ref(false);
const selectedstartDate = ref();
const selectedendDate = ref();
const selectedStartTime = ref({ value: 0, strName: "00:00" });
const selectedEndTime = ref({ value: 23, strName: "23:00" });
const posList = ref([]);
const selectedPos = ref(0);
const selectedCond = ref(0);
const selectedCond2 = ref(2);
const cond2Text = ref("");
const selectedCond3 = ref(1);
const selectedCond4 = ref("전체");
const condition4List = ref([]);

const exceptRetire = (e) => {
  if (e.target.checked) {
    selectedCond3.value = 0;
  } else {
    selectedCond3.value = 1;
  }
};
/**
 * 선택한 매출 시작일자
 */

const startDate = (e) => {
  //comsole.log(e);
  selectedstartDate.value = e;
};

/**
 * 선택한 매출 종료일자
 */

const endDate = (e) => {
  //comsole.log(e);
  selectedendDate.value = e;
};

const datepicker = ref(null);
const closePopUp = ref(false);
/**
 * 매출 일자 안 라디오박스 닫기 위한 외부 클릭 감지 함수
 */

const handleParentClick = (e) => {
  const datepickerEl = datepicker.value?.$el;
  if (datepickerEl && datepickerEl.contains(e.target)) {
    return;
  }
  closePopUp.value = !closePopUp.value;
};

/**
 *  조회 함수
 */

const searchButton = async () => {
  try {
    store.state.loading = true;
    initGrid();

    let cardNo = "";
    let empCode = "";
    let empName = "";
    let custDeptName = "";
    let custCompName = "";
    if (selectedCond2.value == 0) {
      cardNo = cond2Text.value;
    } else if (selectedCond2.value == 1) {
      empCode = cond2Text.value;
    } else if (selectedCond2.value == 2) {
      empName = cond2Text.value;
    } else if (selectedCond2.value == 3) {
      if (isLegacyGroup.value) {
        // 3071 법인: select box 값 사용
        custDeptName = selectedCond4.value === "전체" ? "" : selectedCond4.value;
      } else {
        custDeptName = cond2Text.value;
      }
    } else if (selectedCond2.value == 4) {
      if (isLegacyGroup.value) {
        // 3071 법인: select box 값 사용
        custCompName = selectedCond4.value === "전체" ? "" : selectedCond4.value;
      } else {
        custCompName = cond2Text.value;
      }
    }

    const res = await getSalesbyPostPay(
      selectedGroup.value,
      selectedStores.value,
      selectedstartDate.value,
      selectedendDate.value,
      selectedCond.value,
      cardNo,
      empCode,
      empName,
      custDeptName,
      custCompName,
      selectedCond3.value,
      selectedPos.value
    );
    //comsole.log(res);
    rowData.value = res.data.List;

    afterSearch.value = true;
  } catch (error) {
    afterSearch.value = false;
    //comsole.log(error);
  } finally {
    store.state.loading = false;
  }
};

/* 매장 컴포넌트 관련 함수 */
const selectedGroup = ref();
const selectedStores = ref();
const selectedStoreAttrs = ref();
/**
 * 페이지 매장 그룹 세팅
 */

const lngStoreGroup = (e) => {
  //initGrid();
  //comsole.log(e);
  selectedGroup.value = e;
};
/**
 * 페이지 매장 코드 세팅
 */

const lngStoreCode = async (e) => {
  initGrid();
  selectedStores.value = e;
  const res = await getPosList2(selectedGroup.value, selectedStores.value);
  posList.value = res.data.pos;
  //comsole.log(res);
};

/**
 * 페이지 매장 분류 세팅
 */

const lngStoreAttrs = (e) => {
  initGrid();
  selectedStoreAttrs.value = e;
  //comsole.log(e);
};

/**
 * 그리드 초기화
 */

const initGrid = () => {
  if (rowData.value.length > 0) {
    rowData.value = [];
  }
};

//엑셀 버튼 처리 함수
const exportExcel = ref(false);
/**
 * 엑셀 내보내기 함수
 */

const excelButton = () => {
  let cond =
    "포스 선택 : " + (selectedPos.value == 0 ? "전체" : selectedPos.value);

  let cond2 = "조회 조건 :";

  if (selectedCond.value == 0) {
    cond2 += "전체";
  } else if (selectedCond.value == 1) {
    cond2 += "개인후불";
  } else if (selectedCond.value == 2) {
    cond2 += "부서후불";
  } else if (selectedCond.value == 3) {
    cond2 += "개인카드";
  } else if (selectedCond.value == 4) {
    cond2 += "부서카드";
  }

  let cond3 = "검색조건 : ";
  if (selectedCond2.value == 0) {
    cond3 += "카드번호 , " + cond2Text.value;
  } else if (selectedCond2.value == 1) {
    cond3 += "사원번호 , " + cond2Text.value;
  } else if (selectedCond2.value == 2) {
    cond3 += "사원명 , " + cond2Text.value;
  } else if (selectedCond2.value == 3) {
    cond3 += "부서명 , " + (isLegacyGroup.value ? selectedCond4.value : cond2Text.value);
  } else if (selectedCond2.value == 4) {
    cond3 += "소속사명 , " + (isLegacyGroup.value ? selectedCond4.value : cond2Text.value);
  }

  let cond4 = "조회옵션 :";
  if (setRowGroupSpan2.value != "") {
    cond4 += "셀병합,";
  }
  if (setGroupFooter.value == true) {
    cond4 += "합계,";
  }
  if (selectedCond3.value == 0) {
    cond4 += "퇴직자제외,";
  } else {
    cond4 += "퇴직자포함,";
  }
  cond4 = cond4.substring(0, cond4.length - 1);

  documentSubTitle.value =
    selectedExcelDate.value +
    "\n" +
    selectedExcelStore.value +
    "\n" +
    cond +
    "\n" +
    cond2 +
    "\n" +
    cond3 +
    "\n" +
    cond4;

  exportExcel.value = !exportExcel.value;
};

// 엑셀 추출
const documentSubTitle = ref("");
const selectedExcelDate = ref("");
/**
 * 엑셀용 일자 세팅 함수
 */

const excelDate = (e) => {
  selectedExcelDate.value = e;
  //comsole.log(e);
};
const selectedExcelStore = ref("");
/**
 * 엑셀용 매장 세팅 함수
 */

const excelStore = (e) => {
  selectedExcelStore.value = e;
  //comsole.log(e);
};
const setSum = (e) => {
  if (e.target.checked) {
    setGroupFooter.value = true;
  } else {
    setGroupFooter.value = false;
  }
  reload.value = !reload.value;
};
const setUnite = (e) => {
  if (e.target.checked) {
    setRowGroupSpan2.value =
      "strType,dtmDate,strCompName,lngEmpNo,strEmpName,strDeptInfo";
  } else {
    setRowGroupSpan2.value = "";
  }
  reload.value = !reload.value;
};

/**
 * selectedCond2 변경 시 3071 법인이면 condition4List 로드 (기존 방식)
 */
watch(selectedCond2, async () => {
  if (!isLegacyGroup.value) return;

  if (selectedCond2.value == 3) {
    const res2 = await getCondition4List(
      selectedGroup.value,
      selectedStores.value,
      4
    );
    condition4List.value = res2.data.List;
  } else if (selectedCond2.value == 4) {
    const res2 = await getCondition4List(
      selectedGroup.value,
      selectedStores.value,
      5
    );
    condition4List.value = res2.data.List;
  }
  selectedCond4.value = "전체";
});

/**
 * 새로고침 버튼 함수 (3071 법인 전용)
 */
const searchCondition = async () => {
  if (selectedCond2.value == 3) {
    const res2 = await getCondition4List(
      selectedGroup.value,
      selectedStores.value,
      4
    );
    condition4List.value = res2.data.List;
  } else if (selectedCond2.value == 4) {
    const res2 = await getCondition4List(
      selectedGroup.value,
      selectedStores.value,
      5
    );
    condition4List.value = res2.data.List;
  }
  selectedCond4.value = "전체";
};
</script>